/**
 * Seed airfield list: ICAO → [lat, lon, name]. Used for datalists and the
 * SR/SS computation until the openAIP mirror replaces it (M2). Coordinates are
 * aerodrome reference points.
 */
export const AIRFIELDS = {
    LJLJ: [46.2237, 14.4576, "Ljubljana"],
    LJMB: [46.4797, 15.6861, "Maribor"],
    LJPZ: [45.4733, 13.6150, "Portorož"],
    LJCE: [45.8999, 15.5302, "Cerklje ob Krki"],
    LJCL: [46.2456, 15.2231, "Celje"],
    LJNM: [45.8103, 15.1128, "Novo mesto"],
    LJPT: [46.4306, 15.9861, "Ptuj"],
    LJMS: [46.6631, 16.1758, "Murska Sobota"],
    LJBL: [46.3572, 14.1717, "Lesce-Bled"],
    LJBO: [46.3319, 13.5508, "Bovec"],
    LJAJ: [45.8869, 13.8869, "Ajdovščina"],
    LJSG: [46.4736, 15.1169, "Slovenj Gradec"],
    LJPO: [45.7531, 14.1946, "Postojna"],
    LOWI: [47.2602, 11.3440, "Innsbruck"],
    LOWS: [47.7933, 13.0043, "Salzburg"],
    LOWK: [46.6425, 14.3377, "Klagenfurt"],
    LOWG: [46.9911, 15.4396, "Graz"],
    LOWZ: [47.2933, 12.7883, "Zell am See"],
    LOWL: [48.2332, 14.1875, "Linz"],
    LOWW: [48.1103, 16.5697, "Wien"],
    LDZA: [45.7429, 16.0688, "Zagreb"],
    LDVA: [46.2946, 16.3831, "Varaždin"],
    LDRI: [45.2169, 14.5703, "Rijeka"],
    LDPL: [44.8935, 13.9222, "Pula"],
    LDLO: [44.5658, 14.3931, "Lošinj"],
    LDZD: [44.1083, 15.3467, "Zadar"],
    LIPQ: [45.8275, 13.4722, "Triest"],
    LIPA: [45.9656, 12.6003, "Aviano"],
    LIPI: [45.9786, 13.0493, "Rivolto"],
    LIPZ: [45.5053, 12.3519, "Venedig"],
    LIPH: [45.6484, 12.1944, "Treviso"],
    LIPU: [45.3958, 11.8479, "Padova"],
    LHSM: [46.6864, 17.1592, "Hévíz-Balaton"],
    LHPP: [45.9908, 18.2410, "Pécs"],
    LQBK: [44.9414, 17.2975, "Banja Luka"],
    EDMA: [48.4250, 10.9317, "Augsburg"],
};
export function airfield(icao) {
    const a = AIRFIELDS[icao.toUpperCase()];
    return a ? { lat: a[0], lon: a[1], name: a[2] } : null;
}
//# sourceMappingURL=airfields.js.map